<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-12 col-sm-7">
            <h5 class="card-title">{{ psaCategory }}</h5>
          </div>
          <div class="col-12 col-sm-5 pt-1">
            <div class="psa-header-actions">
              <p-button type="default" @click="newPsa()" title="PSA hinzufügen" class="mt-0 mr-0 psa-action-btn" v-if="role > 1 && psaRole > 1"><i class="bi bi-plus-circle" style="font-size: 16px;"></i> Hinzufügen</p-button>
              <p-button type="default" @click="openManageTemplates()" title="Vorlagen verwalten" class="mt-0 mr-0 psa-action-btn psa-action-btn--icon" v-if="role == 3"><i class="bi bi-file-earmark-text" style="font-size: 16px;"></i></p-button>
              <p-button type="default" @click="openManageCategories()" title="Kategorien verwalten" class="mt-0 mr-0 psa-action-btn psa-action-btn--icon" v-if="role == 3"><i class="bi bi-gear" style="font-size: 16px;"></i></p-button>
              <el-select v-model="psaCategory" placeholder="PSA-Kategorie wählen" @change="updatePsaCategory" class="psa-category-select">
                <el-option v-for="category in psaCategories" :value="category.psaCatName" :label="category.psaCatName" :key="category.key"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row psa-filters">
          <div class="col-12 col-md-6 col-xl-3 mb-3" v-if="multiLocationMode == 1">
            <label>Standorte:</label>
            <el-select v-model="selectedLocations" multiple collapse-tags placeholder="Standorte wählen" @change="onLocationsChange" class="w-100">
              <el-option v-for="loc in locations" :value="loc.key" :label="loc.name" :key="loc.key"></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-xl-3 mb-3">
            <label>Hersteller:</label>
            <el-select v-model="filterManufacturers" multiple collapse-tags clearable placeholder="Alle Hersteller" @change="saveSettings" class="w-100">
              <el-option v-for="manufacturer in availableManufacturers" :value="manufacturer" :label="manufacturer" :key="manufacturer"></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-xl-3 mb-3">
            <label>Letzte Prüfung:</label>
            <el-date-picker v-model="filterLastMaintenance" type="monthrange" unlink-panels range-separator="–" start-placeholder="Von" end-placeholder="Bis" format="MMM yyyy" @change="saveSettings" class="psa-filter-date"></el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-xl-3 mb-3">
            <label>Nächste Prüfung:</label>
            <el-date-picker v-model="filterNextMaintenance" type="monthrange" unlink-panels range-separator="–" start-placeholder="Von" end-placeholder="Bis" format="MMM yyyy" @change="saveSettings" class="psa-filter-date"></el-date-picker>
          </div>
          <div class="col-12 mb-3 text-right" v-if="filtersActive">
            <el-button size="mini" icon="el-icon-refresh-left" @click="resetFilters">Filter zurücksetzen</el-button>
          </div>
        </div>
        <div class="row mb-4 pb-3 pt-2">
          <div class="col-4">
            <el-statistic title="Einsatzbereit" :value=counterOK group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-4">
            <el-statistic title="Prüfung fällig" :value=counterMaintenance group-separator="." :precision="0"></el-statistic>
          </div>
          <div class="col-4">
            <el-statistic title="Nicht einsatzbereit" :value=counterNOK group-separator="." :precision="0"></el-statistic>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table 
            ref="psaTable"
            :data="filteredPsa" header-row-class-name="text-primary" empty-text="Es konnte keine PSA gefunden werden."
              v-loading="loading"
              :default-sort = "{prop: 'psaSerialNumber', order: 'ascending'}"
              @row-click="showDetails"
              @filter-change="onTableFilterChange">
              <el-table-column prop="psaSerialNumber" label="Serien-Nr." min-width="130" sortable></el-table-column>
              <el-table-column prop="psaOwnId" label="Eigene Nr." min-width="130" sortable></el-table-column>
              <el-table-column v-if="multiLocationMode == 1" prop="psaLocationName" label="Standort" min-width="120" sortable></el-table-column>
              <el-table-column prop="psaManufacturer" label="Hersteller" min-width="120"></el-table-column>
              <el-table-column prop="psaItem" label="Artikel"></el-table-column>
              <el-table-column prop="psaStatus" label="Status" min-width="120"
                column-key="psaStatus"
                :filters="[{ text: 'Einsatzbereit', value: 'OK' }, { text: 'Prüfung fällig', value: 'maintenance' }, { text: 'Nicht einsatzbereit', value: 'NOK' }]"
                :filtered-value="filterStatusValues"
                :filter-method="filterStatus"
                filter-placement="bottom-end"
                align="center"
                sortable>
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.psaStatus === 'OK'"
                    type="success"
                    disable-transitions>Einsatzbereit</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'maintenance'"
                    type="warning"
                    disable-transitions>Prüfung fällig</el-tag>
                  <el-tag
                    v-if="scope.row.psaStatus === 'NOK'"
                    type="danger"
                    disable-transitions>Nicht einsatzbereit</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="psaLastMaintenance" label="Letzte Prüfung" min-width="100"></el-table-column>
              <el-table-column prop="psaNextMaintenance" label="Nächste Prüfung" min-width="100"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="showNewPsaModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">PSA hinzufügen</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Vorlage:</label>
          <el-select v-model="newPsaTemplate" placeholder="Ohne Vorlage" clearable @change="templateSelected">
            <el-option v-for="template in psaTemplates" :value=template.psaTemplateName :label=template.psaTemplateName :key=template.key></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Bezeichnung</label>
          <el-input v-model="newPsaName"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Serien-Nummer:</label>
          <el-input v-model="newPsaSerialNumer" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Eigene Nummer:</label>
          <el-input v-model="newPsaOwnId" prefix-icon="el-icon-key" @input="ownIdExists = false" @change="checkOwnIdUnique">
            <el-button slot="append" icon="el-icon-magic-stick" @click="generateOwnId" :loading="generatingOwnId" title="Nächste freie Nummer generieren"></el-button>
          </el-input>
          <el-alert
            v-if="ownIdExists"
            type="error"
            show-icon
            :closable="false"
            class="mt-2"
          >
            Eigene Nummer ist bereits vergeben.
          </el-alert>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="newPsaGalLink" prefix-icon="el-icon-key"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="newPsaManufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value=manufacturer :label=manufacturer :key=manufacturer></el-option>
          </el-select>
        </div>
        <div class="col-md">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="newPsaType" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value=cat.psaCatName :label=cat.psaCatName :key=cat.psaCatName></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Herstellung:</label>
          <el-date-picker v-model="newPsaProdDate" type="month" placeholder="Herstellungsdatum" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
        <div class="col-md">
          <label class="pt-4">Inbetriebnahme:</label>
          <el-date-picker v-model="newPsaFirstUse" type="month" placeholder="Inbetriebnahme" :picker-options="pickerOptions" :clearable="false" format="MMMM yyyy"></el-date-picker>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Lebensdauer (Jahre):</label><br>
          <el-checkbox v-model="newPsaEOLUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="newPsaEOL" :min="1" :max="30" :disabled="newPsaEOLUnlimited"></el-input-number>
        </div>
      </div>
      

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewPsaModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addPsa()" :disabled="ownIdExists == true || newPsaName == '' || (newPsaSerialNumer == '' && newPsaOwnId == '') || newPsaManufacturer == '' || newPsaType == ''">Hinzufügen</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showManageCategoriesModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Kategorien verwalten</h5>
      <div class="row">
        <div class="col">
          <label>Neue Kategorie:</label>
          <el-input v-model="newCategoryName" placeholder="Name der neuen Kategorie">
            <el-button slot="append" icon="el-icon-plus" @click="addCategory" :loading="categoryActionLoading" :disabled="newCategoryName.trim() == ''" title="Hinzufügen"></el-button>
          </el-input>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <label>Bestehende Kategorien:</label>
          <el-table :data="psaCategories" empty-text="Keine Kategorien vorhanden." size="small">
            <el-table-column label="Name">
              <template slot-scope="scope">
                <el-input v-if="editingCategoryKey === scope.row.key" v-model="editingCategoryName" size="small"></el-input>
                <span v-else>{{ scope.row.psaCatName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Aktionen" width="160" align="right">
              <template slot-scope="scope">
                <template v-if="editingCategoryKey === scope.row.key">
                  <el-button type="success" icon="el-icon-check" size="mini" circle @click="saveCategoryRename(scope.row)" :loading="categoryActionLoading" title="Speichern"></el-button>
                  <el-button icon="el-icon-close" size="mini" circle @click="cancelCategoryEdit()" title="Abbrechen"></el-button>
                </template>
                <template v-else>
                  <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="startCategoryEdit(scope.row)" title="Umbenennen"></el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteCategory(scope.row)" :loading="categoryActionLoading" title="Löschen"></el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showManageCategoriesModal=false">Schließen</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showManageTemplatesModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Vorlagen verwalten</h5>
      <div class="row">
        <div class="col">
          <el-table :data="manageTemplates" empty-text="Keine Vorlagen vorhanden." size="small" @row-click="startTemplateEdit">
            <el-table-column prop="psaTemplateName" label="Name" sortable></el-table-column>
            <el-table-column prop="psaType" label="Kategorie" sortable></el-table-column>
            <el-table-column prop="psaManufacturer" label="Hersteller"></el-table-column>
            <el-table-column label="Aktionen" width="110" align="right">
              <template slot-scope="scope">
                <el-button type="primary" icon="el-icon-edit" size="mini" circle @click.stop="startTemplateEdit(scope.row)" title="Bearbeiten"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click.stop="deleteTemplate(scope.row)" :loading="templateActionLoading" title="Löschen"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showManageTemplatesModal=false">Schließen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="startNewTemplate()">Neue Vorlage</p-button>
        </div>
      </template>
    </modal>

    <modal :show.sync="showEditTemplateModal" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">{{ editingTemplateKey ? 'Vorlage bearbeiten' : 'Neue Vorlage' }}</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Name:</label>
          <el-input v-model="templateForm.name"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Artikel:</label>
          <el-input v-model="templateForm.item"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">GAL-Link:</label>
          <el-input v-model="templateForm.galLink"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Hersteller:</label>
          <el-select v-model="templateForm.manufacturer" placeholder="Hersteller auswählen" clearable>
            <el-option v-for="manufacturer in manufacturers" :value="manufacturer" :label="manufacturer" :key="manufacturer"></el-option>
          </el-select>
        </div>
        <div class="col-md">
          <label class="pt-4">Kategorie:</label>
          <el-select v-model="templateForm.type" placeholder="Kategorie auswählen" clearable>
            <el-option v-for="cat in psaCategories" :value="cat.psaCatName" :label="cat.psaCatName" :key="cat.psaCatName"></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label class="pt-4">Lebensdauer (Jahre):</label><br>
          <el-checkbox v-model="templateForm.eolUnlimited" class="mb-2">unbegrenzt</el-checkbox><br>
          <el-input-number style="text-align: center" v-model="templateForm.eol" :min="1" :max="30" :disabled="templateForm.eolUnlimited"></el-input-number>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showEditTemplateModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveTemplate()" :loading="templateActionLoading" :disabled="!templateForm.name.trim() || !templateForm.type || !templateForm.manufacturer">Speichern</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Input, InputNumber, Loading, Popover, Tag, Select, Option, Statistic, MessageBox, Checkbox, Button, DatePicker } from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import locations from "../../../../locationStore";
import psaData from "../../../../../psa.json";
import { psaDate, formatPsaDate } from "../../../../util/psaDates";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Statistic)
Vue.use(Button)

export default {
  components: {
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [Checkbox.name]: Checkbox,
    [DatePicker.name]: DatePicker,
    SelectLocation,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox,
  },

  data() {
    return {
      loading: true,
      psa: [],
      psaUnsub: null,
      psaLoadToken: 0,
      userlocationUnwatch: null,
      multiLocationMode: process.env.VUE_APP_MULTIPLE_LOCATIONS,
      locations: locations.getters.locations.locations,
      selectedLocations: locations.getters.locations.locations.map(l => l.key),
      filterManufacturers: [],
      filterLastMaintenance: null,
      filterNextMaintenance: null,
      filterStatusValues: [],
      search: "",
      showNewPsaModal: false,
      psaTemplates: [],
      newPsaTemplate: "",
      newPsaName: "",
      newPsaGalLink: "",
      newPsaType: "",
      newPsaManufacturer: "",
      newPsaSerialNumer: "",
      newPsaOwnId: "",
      newPsaFirstUse: "",
      newPsaProdDate: "",
      newPsaEOL: 10,
      newPsaEOLUnlimited: false,
      generatingOwnId: false,
      psaCategories: [],
      psaCategory: "",
      ownIdExists: false,
      role: store.getters.userrole,
      psaRole: store.getters.psaRole,
      location: store.getters.userlocation,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      manufacturers: psaData.manufacturers.map(manufacturer => manufacturer.name),
      showManageCategoriesModal: false,
      newCategoryName: "",
      editingCategoryKey: null,
      editingCategoryName: "",
      categoryActionLoading: false,
      showManageTemplatesModal: false,
      showEditTemplateModal: false,
      manageTemplates: [],
      manageTemplatesUnsub: null,
      editingTemplateKey: null,
      templateForm: {
        name: "",
        item: "",
        galLink: "",
        manufacturer: "",
        type: "",
        eol: 10,
        eolUnlimited: false,
      },
      templateActionLoading: false,
    };
  },
  created() {
    if(store.getters.psaRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    }
    moment.locale("de");
    this.loadPsaCategories();
    if(localStorage.SelectedPsaCategory) {
      this.psaCategory = localStorage.SelectedPsaCategory;
    }
    this.loadSettings();
    this.loadPsa();
    this.userlocationUnwatch = store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        // In multi-location mode the list is driven by the location filter, not the global location
        if (this.multiLocationMode != 1) {
          this.loadPsa();
        }
      }
    );
  },
  computed: {
    activeLocations() {
      return this.multiLocationMode == 1 ? this.selectedLocations : [this.location];
    },
    availableManufacturers() {
      const set = new Set(this.filterManufacturers);
      this.psa.forEach(p => { if (p.psaManufacturer) set.add(p.psaManufacturer); });
      return Array.from(set).sort((a, b) => a.localeCompare(b));
    },
    filteredPsa() {
      const search = this.search.toLowerCase();
      return this.psa.filter((row) => {
        if (search && !(row.psaType || "").toLowerCase().includes(search)) return false;
        if (this.filterManufacturers.length && !this.filterManufacturers.includes(row.psaManufacturer)) return false;
        if (!this.inMonthRange(row.psaLastMaintenanceDate, this.filterLastMaintenance)) return false;
        if (!this.inMonthRange(row.psaNextMaintenanceDate, this.filterNextMaintenance)) return false;
        return true;
      });
    },
    counterOK() {
      return this.filteredPsa.filter(x => x.psaStatus == 'OK').length;
    },
    counterNOK() {
      return this.filteredPsa.filter(x => x.psaStatus == 'NOK').length;
    },
    counterMaintenance() {
      return this.filteredPsa.filter(x => x.psaStatus == 'maintenance').length;
    },
    filtersActive() {
      return this.filterManufacturers.length > 0
        || !!this.filterLastMaintenance
        || !!this.filterNextMaintenance
        || this.filterStatusValues.length > 0;
    },
  },
  beforeDestroy() {
    if (this.psaUnsub) {
      this.psaUnsub();
      this.psaUnsub = null;
    }
    if (this.userlocationUnwatch) {
      this.userlocationUnwatch();
      this.userlocationUnwatch = null;
    }
    if (this.manageTemplatesUnsub) {
      this.manageTemplatesUnsub();
      this.manageTemplatesUnsub = null;
    }
  },
  methods: {
    loadPsaCategories() {
      const psaCatRef = db.collection("psaCategories");
      psaCatRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaCategories = [];
        snapshotChange.forEach((doc) => {
          this.psaCategories.push({
            key: doc.id,
            psaCatName: doc.data().Name,
          });
        });
      });
    },
    settingsStorageKey() {
      const user = store.getters.user && store.getters.user.data;
      return "psaOverviewSettings_" + (user && user.uid ? user.uid : "default");
    },
    loadSettings() {
      let settings = null;
      try {
        settings = JSON.parse(localStorage.getItem(this.settingsStorageKey()) || "null");
      } catch (e) {
        settings = null;
      }
      if (!settings) return;
      const toRange = (r) => (Array.isArray(r) && r.length === 2 ? [new Date(r[0]), new Date(r[1])] : null);
      if (Array.isArray(settings.locations)) {
        const validKeys = this.locations.map(l => l.key);
        this.selectedLocations = settings.locations.filter(k => validKeys.includes(k));
      }
      if (Array.isArray(settings.manufacturers)) this.filterManufacturers = settings.manufacturers;
      if (Array.isArray(settings.status)) this.filterStatusValues = settings.status;
      this.filterLastMaintenance = toRange(settings.lastMaintenance);
      this.filterNextMaintenance = toRange(settings.nextMaintenance);
    },
    saveSettings() {
      const toIso = (r) => (Array.isArray(r) && r.length === 2 ? [new Date(r[0]).toISOString(), new Date(r[1]).toISOString()] : null);
      localStorage.setItem(this.settingsStorageKey(), JSON.stringify({
        locations: this.selectedLocations,
        manufacturers: this.filterManufacturers,
        status: this.filterStatusValues,
        lastMaintenance: toIso(this.filterLastMaintenance),
        nextMaintenance: toIso(this.filterNextMaintenance),
      }));
    },
    onLocationsChange() {
      this.saveSettings();
      this.loadPsa();
    },
    onTableFilterChange(filters) {
      if (Object.prototype.hasOwnProperty.call(filters, "psaStatus")) {
        this.filterStatusValues = filters.psaStatus || [];
        this.saveSettings();
      }
    },
    resetFilters() {
      this.filterManufacturers = [];
      this.filterLastMaintenance = null;
      this.filterNextMaintenance = null;
      this.filterStatusValues = [];
      if (this.$refs.psaTable) {
        this.$refs.psaTable.clearFilter("psaStatus");
      }
      this.saveSettings();
    },
    inMonthRange(date, range) {
      if (!Array.isArray(range) || range.length !== 2) return true;
      if (!date) return false;
      return moment(date).isBetween(moment(range[0]).startOf("month"), moment(range[1]).endOf("month"), null, "[]");
    },
    locationName(key) {
      const loc = this.locations.find(l => l.key === key);
      return loc ? loc.name : (key || "");
    },
    loadPsa() {
      if (this.psaUnsub) {
        this.psaUnsub();
        this.psaUnsub = null;
      }
      const token = ++this.psaLoadToken;
      const locs = this.activeLocations.filter(l => l !== undefined && l !== null && l !== "");
      if (locs.length === 0) {
        this.psa = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      const onLoadError = (error) => {
        console.error("Fehler beim Laden der PSA:", error);
        if (token !== this.psaLoadToken) return;
        this.loading = false;
        this.$notify({
          message: "Fehler beim Laden der PSA! Bitte Internetverbindung und PSA-Einträge prüfen.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 10000,
        });
      };
      let psaQuery = db.collection("psa").where('Type', '==', this.psaCategory);
      psaQuery = locs.length === 1
        ? psaQuery.where('locationID', '==', locs[0])
        : psaQuery.where('locationID', 'in', locs);
      this.psaUnsub = psaQuery.where('Status', '!=', "Removed").onSnapshot(async (snapshotChange) => {
        try {
          const psaPromises = snapshotChange.docs.map(async (doc) => {
            const lastMaintenance = formatPsaDate(doc.data().LastMaintenance);
            const nextMaintenance = formatPsaDate(doc.data().NextMaintenance);
            const ProdDate = formatPsaDate(doc.data().ProdDate);
            const FirstUse = formatPsaDate(doc.data().FirstUse);
            var status = doc.data().Status;
            const nextMaintenanceDate = psaDate(doc.data().NextMaintenance);
            if (status == 'maintenance') {
              status = "maintenance";
            } else if (status == 'OK' && nextMaintenanceDate && moment().isSameOrAfter(moment(nextMaintenanceDate))) {
              status = "maintenance";
            } else if (status == 'OK' && nextMaintenanceDate && moment().isBefore(moment(nextMaintenanceDate))) {
              status = "OK";
            }
            const lastMaintenanceRaw = psaDate(doc.data().LastMaintenance);
            const nextMaintenanceRaw = nextMaintenanceDate;
            const buildRow = () => ({
              key: doc.id,
              psaType: doc.data().Type,
              psaManufacturer: doc.data().Manufacturer,
              psaItem: doc.data().Item,
              psaSerialNumber: doc.data().SerialNumber,
              psaOwnId: doc.data().OwnId,
              psaLocation: doc.data().locationID,
              psaLocationName: this.locationName(doc.data().locationID),
              psaProdDate: ProdDate,
              psaFirstUse: FirstUse,
              psaLastMaintenance: lastMaintenance,
              psaNextMaintenance: nextMaintenance,
              psaLastMaintenanceDate: lastMaintenanceRaw,
              psaNextMaintenanceDate: nextMaintenanceRaw,
              psaStatus: status,
            });

            // Check subcomponents in subcollection `components` for EOLDate reached (on or before today)
            const compRef = db.collection('psa').doc(doc.id).collection('components');
            const compSnap = await compRef.get();
            let hasEOLReached = false;
            compSnap.forEach((cdoc) => {
              const cdata = cdoc.data();
              // Skip removed components if schema provides such flags
              if ((cdata && cdata.Status === 'Removed') || (cdata && cdata.Removed === true)) {
                return;
              }
              const eolDate = psaDate(cdata && cdata.EOLDate);
              if (eolDate && moment().isSameOrAfter(moment(eolDate))) {
                hasEOLReached = true;
              }
            });
            // If any subcomponent reached EOL, set to maintenance unless already NOK
            if (hasEOLReached && status !== 'NOK') {
              status = 'maintenance';
            }
            return buildRow();
          });

          const items = await Promise.all(psaPromises);
          if (token !== this.psaLoadToken) return;
          this.psa = items;
          this.loading = false;
        } catch (error) {
          onLoadError(error);
        }
      }, onLoadError);
    },
    showDetails(row, column) {
      if (column.property) {
        router.push({ name: "PsaDetails", params: { psaId: row.key } });
      }
    },
    filterStatus(value, row) {
      return row.psaStatus === value;
    },
    updateLocation(loc) {
      this.location = loc
      this.loadPsa()
    },
    updatePsaCategory(cat) {
      localStorage.SelectedPsaCategory = this.psaCategory
      this.loadPsa()
    },
    newPsa() {
      this.newPsaTemplate = "";
      this.newPsaSerialNumer = "";
      this.newPsaOwnId = "";
      this.newPsaFirstUse = "";
      this.newPsaProdDate = "";
      this.newPsaEOLUnlimited = false;
      this.newPsaEOL = 10;
      this.ownIdExists = false;
      this.showNewPsaModal = true;
      const psaTemplateRef = db.collection("psaTemplates");
      psaTemplateRef.orderBy("Name").onSnapshot((snapshotChange) => {
        this.psaTemplates = [];
        snapshotChange.forEach((doc) => {
          this.psaTemplates.push({
            key: doc.id,
            psaTemplateName: doc.data().Name,
            psaType: doc.data().Type,
            psaManufacturer: doc.data().Manufacturer,
            psaItem: doc.data().Item,
            psaGalLink: doc.data().GalLink,
            psaEOL: doc.data().EOL,
            psaEOLUnlimited: doc.data().EOLUnlimited || false,
          });
        });
      });
    },
    templateSelected() {
      const selectedTemplate = this.psaTemplates.find(t => t.psaTemplateName == this.newPsaTemplate);
      if(selectedTemplate) {
        this.newPsaType = selectedTemplate.psaType;
        this.newPsaManufacturer = selectedTemplate.psaManufacturer;
        this.newPsaName = selectedTemplate.psaItem;
        this.newPsaGalLink = selectedTemplate.psaGalLink;
        if (selectedTemplate.psaEOL === -1 || selectedTemplate.psaEOLUnlimited) {
          this.newPsaEOLUnlimited = true;
          this.newPsaEOL = 10;
        } else {
          this.newPsaEOLUnlimited = false;
          this.newPsaEOL = selectedTemplate.psaEOL || 10;
        }
      } else {
        this.newPsaType = "";
        this.newPsaManufacturer = "";
        this.newPsaName = "";
        this.newPsaGalLink = "";
        this.newPsaEOL = 10;
        this.newPsaEOLUnlimited = false;
      }
    },
    addPsa() {
      console.log(this.newPsaTemplate);
      const psaRef = db.collection("psa");
      const prodDate = this.newPsaProdDate ? new Date(this.newPsaProdDate) : null;
      const firstUse = this.newPsaFirstUse ? new Date(this.newPsaFirstUse) : null;
      const lastMaintenance = firstUse;
      const nextMaintenance = firstUse ? moment(this.newPsaFirstUse).add(1, "years").toDate() : null;
      psaRef.add({
        Type: this.newPsaType,
        Manufacturer: this.newPsaManufacturer,
        Item: this.newPsaName,
        GalLink: this.newPsaGalLink,
        SerialNumber: this.newPsaSerialNumer,
        OwnId: this.newPsaOwnId,
        ProdDate: prodDate,
        FirstUse: firstUse,
        LastMaintenance: lastMaintenance,
        NextMaintenance: nextMaintenance,
        EOL: this.newPsaEOLUnlimited ? 0 : this.newPsaEOL,
        EOLUnlimited: this.newPsaEOLUnlimited,
        Status: 'OK',
        locationID: this.location,
      }).then(() => {
        this.showNewPsaModal = false;
        this.newPsaTemplate = "";
        this.newPsaSerialNumer = "";
        this.newPsaOwnId = "";
        this.newPsaFirstUse = "";
        this.newPsaProdDate = "";
        this.$notify({
          message: "PSA wurde erfolgreich hinzugefügt!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      }).catch((error) => {
        this.$notify({
          message: "Fehler beim Hinzufügen der PSA: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      });
    },
    async checkOwnIdUnique() {
      const ownId = this.newPsaOwnId.trim();
      if(ownId === "") {
        this.ownIdExists = false;
        return;
      }
      // Query Firestore since the loaded list may span multiple locations or be filtered
      try {
        const snap = await db.collection("psa")
          .where('locationID', '==', this.location)
          .where('OwnId', '==', ownId)
          .get();
        if (this.newPsaOwnId.trim() !== ownId) return;
        this.ownIdExists = snap.docs.some(d => d.data().Status !== "Removed");
      } catch (error) {
        console.error("Fehler bei der Prüfung der eigenen Nummer:", error);
      }
    },
    async generateOwnId() {
      this.generatingOwnId = true;
      try {
        const snap = await db.collection("psa")
          .where('locationID', '==', this.location)
          .get();
        const usedNumbers = new Set();
        snap.forEach((doc) => {
          const ownId = doc.data().OwnId;
          if (ownId !== undefined && ownId !== null && ownId !== "") {
            const n = parseInt(String(ownId).trim(), 10);
            if (!isNaN(n)) {
              usedNumbers.add(n);
            }
          }
        });
        let next = 1000;
        while (usedNumbers.has(next)) {
          next++;
        }
        this.newPsaOwnId = String(next);
        this.ownIdExists = false;
      } catch (error) {
        this.$notify({
          message: "Fehler beim Generieren der Nummer: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.generatingOwnId = false;
      }
    },
    openManageCategories() {
      this.newCategoryName = "";
      this.editingCategoryKey = null;
      this.editingCategoryName = "";
      this.showManageCategoriesModal = true;
    },
    async addCategory() {
      const name = this.newCategoryName.trim();
      if (!name) return;
      const exists = this.psaCategories.find(c => c.psaCatName.toLowerCase() === name.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Kategorie mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.categoryActionLoading = true;
      try {
        await db.collection("psaCategories").add({ Name: name });
        this.newCategoryName = "";
        this.$notify({
          message: "Kategorie wurde hinzugefügt.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Hinzufügen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    startCategoryEdit(row) {
      this.editingCategoryKey = row.key;
      this.editingCategoryName = row.psaCatName;
    },
    cancelCategoryEdit() {
      this.editingCategoryKey = null;
      this.editingCategoryName = "";
    },
    async saveCategoryRename(row) {
      const newName = this.editingCategoryName.trim();
      const oldName = row.psaCatName;
      if (!newName || newName === oldName) {
        this.cancelCategoryEdit();
        return;
      }
      const exists = this.psaCategories.find(c => c.key !== row.key && c.psaCatName.toLowerCase() === newName.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Kategorie mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.categoryActionLoading = true;
      try {
        await db.collection("psaCategories").doc(row.key).update({ Name: newName });
        // Update all PSA items (location-independent) that reference the old category name
        const psaSnap = await db.collection("psa").where('Type', '==', oldName).get();
        const updates = [];
        let batch = db.batch();
        let count = 0;
        psaSnap.forEach((doc) => {
          batch.update(doc.ref, { Type: newName });
          count++;
          if (count % 400 === 0) {
            updates.push(batch.commit());
            batch = db.batch();
          }
        });
        if (count % 400 !== 0) {
          updates.push(batch.commit());
        }
        // Also update PSA templates referencing this category
        const tplSnap = await db.collection("psaTemplates").where('Type', '==', oldName).get();
        let tplBatch = db.batch();
        let tplCount = 0;
        tplSnap.forEach((doc) => {
          tplBatch.update(doc.ref, { Type: newName });
          tplCount++;
        });
        if (tplCount > 0) {
          updates.push(tplBatch.commit());
        }
        await Promise.all(updates);
        if (this.psaCategory === oldName) {
          this.psaCategory = newName;
          localStorage.SelectedPsaCategory = newName;
          this.loadPsa();
        }
        this.cancelCategoryEdit();
        this.$notify({
          message: "Kategorie wurde umbenannt.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Umbenennen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    async deleteCategory(row) {
      try {
        await MessageBox.confirm(
          `Soll die Kategorie "${row.psaCatName}" wirklich gelöscht werden?`,
          "Kategorie löschen",
          {
            confirmButtonText: "Löschen",
            cancelButtonText: "Abbrechen",
            type: "warning",
          }
        );
      } catch (e) {
        return;
      }
      this.categoryActionLoading = true;
      try {
        // Check for visible (non-removed) PSA items in any location
        const psaSnap = await db.collection("psa").where('Type', '==', row.psaCatName).get();
        let visibleCount = 0;
        psaSnap.forEach((doc) => {
          if (doc.data().Status !== "Removed") {
            visibleCount++;
          }
        });
        if (visibleCount > 0) {
          this.$notify({
            message: `Die Kategorie kann nicht gelöscht werden, da ihr noch ${visibleCount} sichtbare PSA-Einträge zugeordnet sind.`,
            icon: "fa fa-exclamation-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "warning",
            showClose: true,
            timeout: 6000,
          });
          return;
        }
        await db.collection("psaCategories").doc(row.key).delete();
        if (this.psaCategory === row.psaCatName) {
          this.psaCategory = "";
          localStorage.removeItem("SelectedPsaCategory");
          if (this.psaUnsub) {
            this.psaUnsub();
            this.psaUnsub = null;
          }
          this.psa = [];
        }
        this.$notify({
          message: "Kategorie wurde gelöscht.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Löschen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.categoryActionLoading = false;
      }
    },
    openManageTemplates() {
      this.showManageTemplatesModal = true;
      if (this.manageTemplatesUnsub) {
        this.manageTemplatesUnsub();
      }
      this.manageTemplatesUnsub = db.collection("psaTemplates").orderBy("Name").onSnapshot((snap) => {
        this.manageTemplates = [];
        snap.forEach((doc) => {
          this.manageTemplates.push({
            key: doc.id,
            psaTemplateName: doc.data().Name,
            psaType: doc.data().Type,
            psaManufacturer: doc.data().Manufacturer,
            psaItem: doc.data().Item,
            psaGalLink: doc.data().GalLink,
            psaEOL: doc.data().EOL,
            psaEOLUnlimited: doc.data().EOLUnlimited || false,
          });
        });
      });
    },
    resetTemplateForm() {
      this.templateForm = {
        name: "",
        item: "",
        galLink: "",
        manufacturer: "",
        type: "",
        eol: 10,
        eolUnlimited: false,
      };
      this.editingTemplateKey = null;
    },
    startNewTemplate() {
      this.resetTemplateForm();
      this.showEditTemplateModal = true;
    },
    startTemplateEdit(row) {
      this.editingTemplateKey = row.key;
      this.templateForm = {
        name: row.psaTemplateName || "",
        item: row.psaItem || "",
        galLink: row.psaGalLink || "",
        manufacturer: row.psaManufacturer || "",
        type: row.psaType || "",
        eol: (row.psaEOL && row.psaEOL > 0) ? row.psaEOL : 10,
        eolUnlimited: row.psaEOLUnlimited === true || row.psaEOL === -1 || row.psaEOL === 0,
      };
      this.showEditTemplateModal = true;
    },
    async saveTemplate() {
      const name = this.templateForm.name.trim();
      if (!name || !this.templateForm.type || !this.templateForm.manufacturer) return;
      // Check name uniqueness
      const exists = this.manageTemplates.find(t => t.key !== this.editingTemplateKey && (t.psaTemplateName || "").toLowerCase() === name.toLowerCase());
      if (exists) {
        this.$notify({
          message: "Eine Vorlage mit diesem Namen existiert bereits.",
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "warning",
          showClose: true,
          timeout: 5000,
        });
        return;
      }
      this.templateActionLoading = true;
      const payload = {
        Name: name,
        Item: this.templateForm.item || "",
        GalLink: this.templateForm.galLink || "",
        Manufacturer: this.templateForm.manufacturer,
        Type: this.templateForm.type,
        EOL: this.templateForm.eolUnlimited ? 0 : this.templateForm.eol,
        EOLUnlimited: this.templateForm.eolUnlimited,
      };
      try {
        if (this.editingTemplateKey) {
          await db.collection("psaTemplates").doc(this.editingTemplateKey).update(payload);
        } else {
          await db.collection("psaTemplates").add(payload);
        }
        this.showEditTemplateModal = false;
        this.resetTemplateForm();
        this.$notify({
          message: "Vorlage wurde gespeichert.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Speichern: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.templateActionLoading = false;
      }
    },
    async deleteTemplate(row) {
      try {
        await MessageBox.confirm(
          `Soll die Vorlage "${row.psaTemplateName}" wirklich gelöscht werden?`,
          "Vorlage löschen",
          {
            confirmButtonText: "Löschen",
            cancelButtonText: "Abbrechen",
            type: "warning",
          }
        );
      } catch (e) {
        return;
      }
      this.templateActionLoading = true;
      try {
        await db.collection("psaTemplates").doc(row.key).delete();
        this.$notify({
          message: "Vorlage wurde gelöscht.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
      } catch (error) {
        this.$notify({
          message: "Fehler beim Löschen: " + error,
          icon: "fa fa-exclamation-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.templateActionLoading = false;
      }
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
}
.psa-header-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.psa-header-actions .psa-action-btn {
  flex: 0 0 auto;
  margin-top: 0;
  margin-bottom: 0;
}
.psa-header-actions .psa-category-select {
  flex: 1 1 auto;
  min-width: 0;
}
.psa-header-actions .psa-category-select .el-input__inner {
  width: 100%;
}
.psa-filters .el-select,
.psa-filters .psa-filter-date.el-date-editor {
  width: 100%;
}
.el-statistic .con .title,
.el-statistic .head,
.el-statistic .title {
  white-space: normal !important;
  word-break: keep-all !important;
  overflow-wrap: normal !important;
  hyphens: none !important;
}
@media (max-width: 575.98px) {
  .psa-header-actions {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 6px;
  }
  .psa-header-actions .psa-action-btn {
    flex: 1 1 0;
    min-width: 0;
    white-space: nowrap;
  }
  .psa-header-actions .psa-action-btn--icon {
    flex: 0 0 auto;
    padding-left: 14px;
    padding-right: 14px;
  }
  .psa-header-actions .psa-category-select {
    flex: 1 1 100%;
    order: 10;
  }
  .el-statistic .con .title,
  .el-statistic .head,
  .el-statistic .title {
    font-size: 12px;
  }
}
</style>